// import React from 'react';
// import './UpdatesSection.css';
// import { Link } from 'react-router-dom';

// export default function UpdatesSection() {
//   const announcements = [
//     {
//       id: 1,
//       type: 'Admission',
//       date: 'July 15, 2025',
//       isNew: true,
//       text: 'Admissions Open for AY 2025–26 July Session',
//       typeClass: 'badge-admission'
//     },
//     {
//       id: 2,
//       type: 'Exam',
//       date: 'July 10, 2025',
//       isNew: false,
//       text: 'June 2025 Examination Results Published',
//       typeClass: 'badge-exam'
//     },
//     {
//       id: 3,
//       type: 'Assignment',
//       date: 'July 5, 2025',
//       isNew: true,
//       text: 'Assignment Submission Last Date: July 31, 2025',
//       typeClass: 'badge-assignment'
//     },
//     {
//       id: 4,
//       type: 'Holiday',
//       date: 'June 28, 2025',
//       isNew: false,
//       text: 'University Closed on July 19 – Regional Holiday',
//       typeClass: 'badge-holiday'
//     },
//     {
//       id: 5,
//       type: 'Event',
//       date: 'June 20, 2025',
//       isNew: false,
//       text: 'Annual Convocation Ceremony – August 10, 2025',
//       typeClass: 'badge-event'
//     }
//   ];

//   const quickActions = [
//     { id: 1, title: 'Apply Online', desc: 'Start your admission process', icon: '🎓', styleClass: 'action-navy' },
//     { id: 2, title: 'Prospectus', desc: 'AY 2025–26 Prospectus', icon: '📥', styleClass: 'action-yellow' },
//     { id: 3, title: 'Enquiry', desc: 'Have questions? Contact us', icon: '🔔', styleClass: 'action-white' },
//     { id: 4, title: 'Student Login', desc: 'Access your student portal', icon: '👥', styleClass: 'action-white' },
//     { id: 5, title: 'Fee Structure', desc: 'View program-wise fees', icon: '📖', styleClass: 'action-white' },
//     { id: 6, title: 'Study Centres', desc: 'Find a centre near you', icon: '🏢', styleClass: 'action-white' }
//   ];

//   return (
//     <section className="updates-section-wrapper" id="announcements">
//       <div className="updates-container">
        
//         {/* Left Grid: Announcements & News Column */}
//         <div className="announcements-column">
//           <div className="column-header">
//             <div>
//               <span className="section-tag">LATEST UPDATES</span>
//               <h2 className="section-title">Announcements &amp; News</h2>
//             </div>
//             <a href="#all-news" className="view-all-link">View All ➔</a>
//           </div>

//           <div className="announcements-list">
//             {announcements.map((item) => (
//               <div key={item.id} className="news-card">
//                 <div className="news-card-top">
//                   <div className="badge-wrapper">
//                     <span className="live-dot"></span>
//                     <span className={`type-badge ${item.typeClass}`}>{item.type}</span>
//                   </div>
//                   <span className="news-date">{item.date}</span>
//                   {item.isNew && <span className="new-tag">NEW</span>}
//                 </div>
//                 <div className="news-card-body">
//                   <p className="news-text">{item.text}</p>
//                   <span className="card-arrow">➔</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Right Grid: Quick Actions Column */}
//         <div className="actions-column">
//           <h2 className="section-title actions-title-adjust">Quick Actions</h2>
          
//           <div className="actions-list">
//             {quickActions.map((action) => (
//              <Link to={`${action.title.toLowerCase().replace(/ /g, '-')}`} key={action.id} className={`action-row-card ${action.styleClass}`}>
//                 <div className="action-left-content">
//                   <div className="action-icon-container">
//                     <span>{action.icon}</span>
//                   </div>
//                   <div className="action-text-container">
//                     <h3>{action.title}</h3>
//                     <p>{action.desc}</p>
//                   </div>
//                 </div>
//                 <span className="action-chevron">➔</span>
//               </Link>
//             ))}
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// }


import React, { useEffect, useState } from 'react';
import './UpdatesSection.css';
import { Link } from 'react-router-dom';

const API_URL = 'https://metapi.emedhatechnologies.com/api/courses/api/announcements';

export default function UpdatesSection() {
  const [announcements, setItems] = useState([]);

  // Fetch Announcements from API
  const fetchAnnouncements = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setItems(data);
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  // Helper function to map API category to CSS class name
  const getCategoryClass = (category) => {
    if (!category) return 'badge-default';
    switch (category.toLowerCase()) {
      case 'admission':
        return 'badge-admission';
      case 'exam':
        return 'badge-exam';
      case 'assignment':
        return 'badge-assignment';
      case 'holiday':
        return 'badge-holiday';
      case 'event':
        return 'badge-event';
      default:
        return 'badge-default';
    }
  };

  // Helper function to format SQL Date -> "July 15, 2025"
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const quickActions = [
    { id: 1, title: 'Apply Online', desc: 'Start your admission process', icon: '🎓', styleClass: 'action-navy' },
    { id: 2, title: 'Prospectus', desc: 'AY 2025–26 Prospectus', icon: '📥', styleClass: 'action-yellow' },
    { id: 3, title: 'Enquiry', desc: 'Have questions? Contact us', icon: '🔔', styleClass: 'action-white' },
    { id: 4, title: 'Student Login', desc: 'Access your student portal', icon: '👥', styleClass: 'action-white' },
    { id: 5, title: 'Fee Structure', desc: 'View program-wise fees', icon: '📖', styleClass: 'action-white' },
    { id: 6, title: 'Study Centres', desc: 'Find a centre near you', icon: '🏢', styleClass: 'action-white' }
  ];

  return (
    <section className="updates-section-wrapper" id="announcements">
      <div className="updates-container">
        
        {/* Left Grid: Announcements & News Column */}
        <div className="announcements-column">
          <div className="column-header">
            <div>
              <span className="section-tag">
                {announcements.length > 0 && announcements[0].header_title 
                  ? announcements[0].header_title 
                  : 'LATEST UPDATES'}
              </span>
              <h2 className="section-title">Announcements &amp; News</h2>
            </div>
            <a href="#all-news" className="view-all-link">View All ➔</a>
          </div>

          <div className="announcements-list">
            {announcements.map((item) => (
              <div key={item.id} className="news-card">
                <div className="news-card-top">
                  <div className="badge-wrapper">
                    <span className="live-dot"></span>
                    <span className={`type-badge ${getCategoryClass(item.category)}`}>
                      {item.category}
                    </span>
                  </div>
                  <span className="news-date">{formatDate(item.date_posted)}</span>
                  {Boolean(item.is_new) && <span className="new-tag">NEW</span>}
                </div>
                <div className="news-card-body">
                  <p className="news-text">{item.title}</p>
                  <span className="card-arrow">➔</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Grid: Quick Actions Column */}
        <div className="actions-column">
          <h2 className="section-title actions-title-adjust">Quick Actions</h2>
          
          <div className="actions-list">
            {quickActions.map((action) => (
              <Link 
                to={`/${action.title.toLowerCase().replace(/ /g, '-')}`} 
                key={action.id} 
                className={`action-row-card ${action.styleClass}`}
              >
                <div className="action-left-content">
                  <div className="action-icon-container">
                    <span>{action.icon}</span>
                  </div>
                  <div className="action-text-container">
                    <h3>{action.title}</h3>
                    <p>{action.desc}</p>
                  </div>
                </div>
                <span className="action-chevron">➔</span>
              </Link>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}